export const ApiEndpoints = {
    // ApiService
    BASE_URL: '/v2.10',

    // InitService
    INIT: '/init',

    // InHouseTasksService
    EARN_DATA: '/earn_data',
    EARN_OPTIONS: '/earn_options',
    RESEND_OTP: '/verification/send_sms_code',
    PHONE_VERIFICATION: '/verification/verify',
    OTP_VERIFICATION: '/verification/verify_sms_code',

    // LeaderboardService
    LEADERBOARD: '/leaderboard',

    // LoginService
    LOGIN: '/authorize',

    // OfferService
    OFFERS: '/offers/all',
    RATE_OFFER: '/offers/offer',
    START_OFFER: '/offers/offer',
    REPORT_OFFER: '/offers/offer',
    OFFER_BY_ID: '/offer',
    DAILY_PICKS: '/offers/home/feed',
    DAILY_OFFERS: '/offers/home/tabbed',

    // OfferStatusService
    OFFERS_PROGRESS: '/offers/progress',

    // PayoutService
    PAYOUT_OPTIONS: '/payout_options',
    MY_PAYOUT_DATA: '/payout_data',

    // SupportService
    CONTACT_US: '/email',
    FAQ: '/faq',

    // UserService
    USER: '/user',
    MY_REFERRALS: '/referrals',
    DELETE_ACCOUNT: '/delete_user',
    UPDATE_PHONE_NUMBER: '/user/phone_number',
    OFFER_WALL_CLICK_COUNT: '/user/update_offerwall_click_count',

    // SpinTheWheelService
    SPIN_THE_WHEEL: '/spin_the_wheel',
};